<div class="not-found-top-bar"></div>
<header class="not-found-header">
  <div class="header-wrapper">
    <a href="/">
      <figure class="logo">
        <img alt="Logo" src="/assets/images/logo.svg">
        <figcaption>
          <span>Overheids</span>
          <span>doorstroomtoets</span>
        </figcaption>
      </figure>
    </a>
  </div>
</header>

<main class="not-found-main">
  <div class="main-wrapper">
    <ul class="breadcrumbs">
      <li><a href="/">Home</a></li>
      <li class="active">Pagina niet gevonden</li>
    </ul>
  </div>
  <hr>
</main>
